module.exports = __webpack_public_path__ + "static/img/sales.34313fc.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/channels/sales.png
// module id = BaWK
// module chunks = 1